export interface User {
  id: string;
  name: string;
  email: string;
  role: 'student' | 'teacher';
}

export interface Lesson {
  id: string;
  title: string;
  description: string;
  dateCreated: string;
  status: 'draft' | 'published';
}

export interface Class {
  id: string;
  name: string;
  description: string;
}

export const mockClasses: Class[] = [
  {
    id: '1',
    name: 'Programming Basics 2025',
    description: 'Introduction to programming concepts',
  },
  {
    id: '2',
    name: 'Web Development 2025',
    description: 'Learn web development with React',
  },
  {
    id: '3',
    name: 'Data Structures 2025',
    description: 'Advanced programming concepts',
  },
];

export const mockLessons: Lesson[] = [
  {
    id: '1',
    title: 'Variables and Data Types',
    description: 'Learn about different types of variables',
    dateCreated: '2025-08-20',
    status: 'published',
  },
  {
    id: '2',
    title: 'Control Flow',
    description: 'Understanding if statements and loops',
    dateCreated: '2025-08-19',
    status: 'published',
  },
  {
    id: '3',
    title: 'Functions',
    description: 'Working with functions and parameters',
    dateCreated: '2025-08-18',
    status: 'draft',
  },
];

export const mockUsers: User[] = [
  {
    id: '1',
    name: 'John Doe',
    email: 'john@example.com',
    role: 'student',
  },
  {
    id: '2',
    name: 'Jane Smith',
    email: 'jane@example.com',
    role: 'student',
  },
  {
    id: '3',
    name: 'Bob Johnson',
    email: 'bob@example.com',
    role: 'teacher',
  },
  {
    id: '4',
    name: 'Alice Brown',
    email: 'alice@example.com',
    role: 'student',
  },
];
